<div class="simple-keyboard" [class.show-keyboard]="showKeyboard" (click)="clickedInside($event)"></div>

